import {
	ProgressRadial,
	useLanguageResource,
} from "@ruter-as/web-components-and-tools";
import type React from "react";
import "./Loading.scss";
import loadingLanguageResource from "./lang-resource";

const Loading: React.FC = () => {
	const lang = useLanguageResource(loadingLanguageResource);
	return (
		<div className="loading-page">
			<ProgressRadial />
			<div className="loading-text">{lang.loading}</div>
		</div>
	);
};

export default Loading;
